(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  const initialiseCarousel = (grid) => {
    if (grid.dataset.sparkPairReady === 'true') return;

    const section = grid.closest('section');
    const controls = section?.querySelector('[data-spark-pair-controls]');
    if (!controls) return;

    grid.dataset.sparkPairReady = 'true';
    const previousButton = controls.querySelector('[data-spark-pair-prev]');
    const nextButton = controls.querySelector('[data-spark-pair-next]');
    const currentLabel = controls.querySelector('[data-spark-pair-current]');
    const totalLabel = controls.querySelector('[data-spark-pair-total]');

    const applyMobileLimit = () => {
      Array.from(grid.children).forEach((item, index) => {
        item.hidden = MOBILE_QUERY.matches && index >= 4;
      });
    };
    const itemCount = () => Array.from(grid.children).filter((item) => !item.hidden).length;
    const pageCount = () => Math.max(1, Math.ceil(itemCount() / 2));
    const pageWidth = () => Math.max(1, grid.clientWidth);

    const update = () => {
      applyMobileLimit();
      const total = pageCount();
      const current = Math.min(total, Math.max(1, Math.round(grid.scrollLeft / pageWidth()) + 1));
      currentLabel.textContent = String(current);
      totalLabel.textContent = String(total);
      previousButton.disabled = current <= 1;
      nextButton.disabled = current >= total;
      controls.hidden = !MOBILE_QUERY.matches || total <= 1;
    };

    previousButton.addEventListener('click', () => {
      grid.scrollBy({ left: -pageWidth(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      grid.scrollBy({ left: pageWidth(), behavior: 'smooth' });
    });

    let scrollFrame;
    grid.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(update);
    }, { passive: true });

    new MutationObserver(update).observe(grid, { childList: true });
    window.addEventListener('resize', update, { passive: true });
    MOBILE_QUERY.addEventListener?.('change', update);
    update();
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-spark-pair-carousel]').forEach(initialiseCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
